"use client";
import React, { useState } from "react";
import styles from "./ContactUs.module.css";

const PropertyInquiryForm = () => {
  const initialFormData = {
    fullName: "",
    email: "",
    phone: "",
    contactMode: "",
    propertyType: [],
    location: "",
    bhkType: [],
    otherBHK: "",
    purpose: "",
    minBudget: "",
    maxBudget: "",
    finance: "",
    timeline: "",
    meetingDay: "",
    meetingDate: "",
    meetingTime: "",
    amenities: "",
    considerations: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [, setSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter((item) => item !== value),
      }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (validateForm()) {
      setSuccessMessage("Submitting your form...");
      try {
     const response = await fetch('https://pp-backend-1-sa8p.onrender.com/api/submit-form', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(formData),
});

        if (response.ok) {
          setSuccessMessage("Form submitted successfully! Redirecting...");
          setTimeout(() => {
            setFormData(initialFormData);
            setSubmitted(false);
            setSuccessMessage("");
          }, 2000);
        } else {
          setSuccessMessage(
            "Failed to submit the form. Please try again."
          );
        }
      } catch (error) {
        setSuccessMessage("An error occurred. Please try again.");
      }
    } else {
      setSuccessMessage(
        "Please correct the errors before submitting."
      );
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (
      !formData.email.trim() ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    )
      newErrors.email = "Valid Email is required.";
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Valid 10-digit Phone Number is required.";
    if (!formData.contactMode) newErrors.contactMode = "Please select a contact mode.";
    if (formData.propertyType.length === 0)
      newErrors.propertyType = "Please select at least one property type.";
    if (!formData.location.trim()) newErrors.location = "Preferred Location is required.";
    if (formData.bhkType.length === 0) newErrors.bhkType = "Please select at least one BHK.";
    if (formData.bhkType.includes("Other") && !formData.otherBHK.trim())
      newErrors.otherBHK = "Please specify other BHK.";
    if (!formData.purpose) newErrors.purpose = "Please select a purpose.";
    if (!formData.minBudget || Number(formData.minBudget) < 0)
      newErrors.minBudget = "Enter a valid minimum budget.";
    if (
      !formData.maxBudget ||
      Number(formData.maxBudget) <= Number(formData.minBudget)
    )
      newErrors.maxBudget = "Max budget must be greater than min budget.";
    if (!formData.finance) newErrors.finance = "Please specify finance assistance.";
    if (!formData.timeline) newErrors.timeline = "Please select a timeline.";
    if (!formData.meetingDay) newErrors.meetingDay = "Please select a meeting day.";
    if (!formData.meetingDate) newErrors.meetingDate = "Please select a meeting date.";
    if (!formData.meetingTime) newErrors.meetingTime = "Please select a meeting time.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
  
  <div className={styles.formPage}>
    <div className={styles.formContainer}>
      <img
        src="/Property_Plateau_logo.jpg"
        alt="Property Plateau Logo"
        className={styles.logo}
      />
      <h2 className={styles.heading}>Property Inquiry Form</h2>
      <p className={styles.subtitle}>Thank you for reaching out to Property Plateau Realty!</p>
      

        <form onSubmit={handleSubmit}>
          {/* Basic Info */}
          <section className={styles.section}>
            <h3>Basic Information</h3>
            <input
              name="fullName"
              type="text"
              placeholder="Full Name"
              onChange={handleChange}
              value={formData.fullName}
              className={styles.inputField}
            />
            {errors.fullName && <p className={styles.error}>{errors.fullName}</p>}

            <input
              name="email"
              type="email"
              placeholder="Email"
              onChange={handleChange}
              value={formData.email}
              className={styles.inputField}
            />
            {errors.email && <p className={styles.error}>{errors.email}</p>}

            <input
              name="phone"
              type="tel"
              placeholder="Phone Number"
              onChange={handleChange}
              value={formData.phone}
              className={styles.inputField}
            />
            {errors.phone && <p className={styles.error}>{errors.phone}</p>}

            <select
              name="contactMode"
              onChange={handleChange}
              value={formData.contactMode}
              className={styles.selectField}
            >
              <option value="">Preferred Mode of Contact</option>
              <option value="Call">Call</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Email">Email</option>
            </select>
            {errors.contactMode && <p className={styles.error}>{errors.contactMode}</p>}
          </section>

          {/* Property Preferences */}
          <section className={styles.section}>
            <h3>Property Preferences</h3>
            <div className={styles.checkboxGroup}>
              {["Apartment", "Villa", "Plot", "Commercial"].map((opt) => (
                <label key={opt}>
                  <input
                    type="checkbox"
                    name="propertyType"
                    value={opt}
                    checked={formData.propertyType.includes(opt)}
                    onChange={handleChange}
                  />
                  {opt}
                </label>
              ))}
            </div>
            {errors.propertyType && <p className={styles.error}>{errors.propertyType}</p>}

            <input
              name="location"
              type="text"
              placeholder="Preferred Location(s)"
              onChange={handleChange}
              value={formData.location}
              className={styles.inputField}
            />
            {errors.location && <p className={styles.error}>{errors.location}</p>}

            <div className={styles.checkboxGroup}>
              {["1 BHK", "2 BHK", "3 BHK+", "Other"].map((bhk) => (
                <label key={bhk}>
                  <input
                    type="checkbox"
                    name="bhkType"
                    value={bhk}
                    checked={formData.bhkType.includes(bhk)}
                    onChange={handleChange}
                  />
                  {bhk}
                </label>
              ))}
            </div>
            <input
              name="otherBHK"
              type="text"
              placeholder="Specify other BHK"
              onChange={handleChange}
              value={formData.otherBHK}
              className={styles.inputField}
            />
            {errors.bhkType && <p className={styles.error}>{errors.bhkType}</p>}
<select
  name="finance"
  onChange={handleChange}
  value={formData.finance}
  className={styles.selectField}
>
  <option value="">Do you need Finance Assistance?</option>
  <option value="Yes">Yes</option>
  <option value="No">No</option>
</select>
{errors.finance && <p className={styles.error}>{errors.finance}</p>}

            <select
              name="purpose"
              onChange={handleChange}
              value={formData.purpose}
              className={styles.selectField}
            >
              <option value="">Purpose</option>
              <option value="New Home">New Home</option>
              <option value="Investment">Investment</option>
            </select>
            {errors.purpose && <p className={styles.error}>{errors.purpose}</p>}
          </section>

          {/* Budget */}
          <section className={styles.section}>
            <h3>Budget & Financing</h3>
            <input
              name="minBudget"
              type="number"
              placeholder="Min Budget (₹)"
              onChange={handleChange}
              value={formData.minBudget}
              className={styles.inputField}
            />
            {errors.minBudget && <p className={styles.error}>{errors.minBudget}</p>}

            <input
              name="maxBudget"
              type="number"
              placeholder="Max Budget (₹)"
              onChange={handleChange}
              value={formData.maxBudget}
              className={styles.inputField}
            />
            {errors.maxBudget && <p className={styles.error}>{errors.maxBudget}</p>}


            <select
              name="timeline"
              onChange={handleChange}
              value={formData.timeline}
              className={styles.selectField}
            >
              <option value="">Purchase Timeline</option>
              <option value="Immediate">Immediate</option>
              <option value="3-6 Months">3-6 Months</option>
              <option value="6+ Months">6+ Months</option>
            </select>
            {errors.timeline && <p className={styles.error}>{errors.timeline}</p>}
          </section>

          {/* Meeting */}
          <section className={styles.section}>
            <h3>Meeting Preferences</h3>
            <select
              name="meetingDay"
              onChange={handleChange}
              value={formData.meetingDay}
              className={styles.selectField}
            >
              <option value="">Preferred Day</option>
              {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map((day) => (
                <option key={day}>{day}</option>
              ))}
            </select>
            {errors.meetingDay && <p className={styles.error}>{errors.meetingDay}</p>}

            <input
              name="meetingDate"
              type="date"
              onChange={handleChange}
              value={formData.meetingDate}
              className={styles.inputField}
            />
            {errors.meetingDate && <p className={styles.error}>{errors.meetingDate}</p>}

            <input
              name="meetingTime"
              type="time"
              onChange={handleChange}
              value={formData.meetingTime}
              className={styles.inputField}
            />
            {errors.meetingTime && <p className={styles.error}>{errors.meetingTime}</p>}

            <textarea
              name="amenities"
              placeholder="Desired amenities"
              onChange={handleChange}
              value={formData.amenities}
              className={styles.textareaField}
            ></textarea>

            <textarea
              name="considerations"
              placeholder="Other considerations"
              onChange={handleChange}
              value={formData.considerations}
              className={styles.textareaField}
            ></textarea>
          </section>

          <button type="submit" className={styles.submitButton}>Submit</button>
          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default PropertyInquiryForm;
